import React from 'react';
import PropTypes from 'prop-types';
import BrandRankingItem from './BrandRankingItem';
import BrandRankingMore from './BrandRankingMore';

export default function BrandRankingList({ ranking }) {
  if (!ranking || ranking.length === 0) {
    return <div className="BrandRankingList-empty">데이터가 없습니다.</div>;
  }

  return (
    <div>
      <ol className="BrandRankingList">
        {ranking.map((brand, idx) => (
          <BrandRankingItem key={brand.id} rank={idx + 1} brand={brand} isLast={idx === ranking.length - 1} />
        ))}
      </ol>
      <BrandRankingMore to="/brands/all" />
    </div>
  );
}

BrandRankingList.propTypes = {
  ranking: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      country: PropTypes.string,
      thumbnail: PropTypes.string,
    }),
  ).isRequired,
};
